module.exports = __webpack_public_path__ + "img/060_Erde_Mond.f69ad692.jpg";